/**
 * Authorization Roles
 */
const authRoles = {
    admin    : ['admin'],
    staff    : ['admin', 'staff'],
    user     : ['admin', 'staff', 'user'],
    onlyGuest: ['guest']
};

export default authRoles;



// WEBPACK FOOTER //
// ./src/auth/authRoles.js